<template>
  <div class="wrapper">
    <b-container>
      <b-row>
        <div v-html="content" class="text"></div>
      </b-row>
      <b-row v-if="$route.query.mode">
        <button class="btn" @click="showPop">点击在线申请</button>
        <sign-up-pop :show="show" @onclose="onclose"></sign-up-pop>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import signUpPop from "@/forumViews/contact/components/signUpPop";
export default {
  components: {
    signUpPop,
  },
  data() {
    return {
      show: false,
      content: "",
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.getInfo(to.query.typeId);
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    showPop() {
      this.show = true;
    },
    onclose() {
      this.show = false;
    },
    getInfo(typeId) {
      this.$forumApi
        .contentInfo({
          type: typeId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.content = res.data.content;
            console.log(res.data.typeName);
            this.$store.state.browserTitle =  res.data.typeName + " - 未来论坛"
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  width: 20rem;
  color: #fff;
  background-color: $forum-theme-blue;
}

.wrapper::v-deep {
  .text {
    padding: 2rem 1rem 0rem 2rem;
    line-height: 2.5rem;
  }

  img {
    // width: 85% !important;
    max-width: 85% !important;
    height: 100% !important;
  }
}

@media (min-width: 992px) {
  .wrapper::v-deep {
    .text {
      padding-top: 2rem;
      overflow-x: hidden;
      font-size: 1.1rem;
      line-height: 2.5rem;
    }
    img {
      width: 60% !important;
      height: 100% !important;
    }
  }
}
</style>